module.exports = __webpack_public_path__ + "/ca05a94e13568fc68c5674e975f2e54a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/screenshot_box.png
 ** module id = 1254
 ** module chunks = 0
 **/